<template>
  <div class="newsItem">
    <img :src="list.imgSrc"/>
    <article>
      <h1>{{list.title}}</h1>
      <p class="info">
        <img class="icon" src="../../assets/home/u70.png" />
        <span>{{list.date}}</span>
        <img class="icon" src="../../assets/home/u72.png" />
        <span>{{list.seer}}次</span>
      </p>
      <p class="content">{{list.content}}</p>
      <i class="toDetail" @click="goDetail" >查看详情 --></i>
    </article>
  </div>
</template>
<script>
export default {
  props: {
    id: {
      type: Number
    },
    imgSrc: {
      default: require('./u234.png')
    },
    title: {
      type: String,
      default: 'XXXCC'
    },
    content: {
      type: String,
      default: 'XXXXXXXXXXXXXXXXXXXXXXXXX...'
    },
    tab: {
      type: Number
    },
    data: {
      type: Object
    }
  },
  data () {
    return {
      list: this.data
    }
  },
  methods: {
    goDetail () {
      this.$router.push({name: 'b-newsDetail',params: {id: this.list.id}, query: { tab: this.list.title}})
    }
  }
}
</script>

<style lang="stylus" scoped>
.newsItem
  overflow hidden
  padding-bottom 20px
  margin-bottom 20px
  // border-bottom 1px solid #cccccc
  >img
  article
    float left
  >img
    width 25%
    height 250px
  article
    width 75%
    padding 10px 20px
    position relative
    >h1
      font-size 20px
      font-weight bold
    .content
      font-size 14px
      text-indent 28px
      line-height  28px

.icon
  width 20px
  height 20px
.info
  font-size 14px
  color #cccccc
  border-bottom 1px solid #cccccc
  margin: 20px 0
  padding-bottom: 10px
  span
    display inline-block
    margin 0 20px

.toDetail
  position absolute
  bottom -30%
  right 20px
  cursor pointer
  color globalFontColor
</style>
